
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13.5","r":"13","fill":"#00C334","fill-opacity":"0.25"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 20C12.6667 20 12.3965 19.7053 12.3965 19.3418V9.24723L8.8301 13.1374C8.59446 13.3945 8.21237 13.3945 7.97673 13.1374C7.74103 12.8803 7.74103 12.4636 7.97673 12.2065L12.5733 7.19277C12.8089 6.93574 13.191 6.93574 13.4266 7.19277L18.0232 12.2065C18.2589 12.4636 18.2589 12.8803 18.0232 13.1374C17.7876 13.3945 17.4055 13.3945 17.1698 13.1374L13.6034 9.24723V19.3418C13.6034 19.7053 13.3332 20 13 20Z","fill":"#00C334"}})])
          )
        }
      }
    